import { createContext, DependencyList, ReactNode } from "react";

/**
 * New look (desktop): the list controls built by the bots page wrapper (search
 * and filters), handed to the bots list header so they sit with sorting and
 * layout in one row right above the bots.
 */
export interface NewLookBotsToolbar {
  search?: ReactNode;
  filtersButton?: ReactNode;
  /** The filter fields, shown under the list header while open. */
  filtersChips?: ReactNode;
  filtersOpen?: boolean;
  /** Filters or search are narrowing the list. */
  isFiltering?: boolean;
  /** Page actions (webhook URL, create bot): end of the list header. */
  pageActions?: ReactNode;
  /** The same actions without a primary button (next to an empty state). */
  quietPageActions?: ReactNode;
  /** What `pageActions` depends on (for the page toolbar fallback). */
  pageActionsDeps: DependencyList;
}

export const NewLookBotsToolbarContext = createContext<
  NewLookBotsToolbar | undefined
>(undefined);
